import { useQueryClient } from '@tanstack/react-query';
import type { BulkDeleteNotesApiResponse, BulkDeleteNotesRequest } from '@/types/note-list';
import { useApi } from './useApi';
import { useModeAwareMutation } from './useModeAwareQuery';

/**
 * Shared multi-note delete mutation: every note domain posts the same request to its own
 * bulk-delete endpoint and invalidates its own note/activity/audit queries.
 */
export function useBulkDeleteNotes(endpoint: string, invalidateQueryKeys: readonly string[]) {
  const { apiPost } = useApi();
  const queryClient = useQueryClient();

  return useModeAwareMutation<BulkDeleteNotesApiResponse, Error, BulkDeleteNotesRequest>(
    async (request) => apiPost<BulkDeleteNotesApiResponse>(endpoint, request),
    (request) => ({ deletedCount: request.noteIds.length, failedNoteIds: [] }),
    {
      onSuccess: () => {
        for (const key of invalidateQueryKeys) {
          queryClient.invalidateQueries({ queryKey: [key] });
        }
      },
    },
  );
}
